export default "__VITE_ASSET__30585890__"